import { Affix, Button, Card, Form } from "antd";
import { PACKING_REPORT_TEMPLATE_VIEW } from "apiServices/API_ENDPOINTS";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../../../apiServices/common";
import { isMobileView } from "../../../Common/AppHelper";
import Header from "../../../Common/Header";
import AddPackingReportTemplateForm from "./AddPackingReportTemplateForm";

export default function ViewPackingReportTemplate(props) {
  const { width } = props;

  const [viewData, setViewData] = useState();

  let { id } = useParams();
  let show_approve = 1;
  const propertyFormRef = useRef(null);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/ex-factory/packing-report-template");
  };

  const getPackingReportTemplateInfo = useCallback(async () => {
    let res = await getData(`${PACKING_REPORT_TEMPLATE_VIEW}/${id}`);
    if (res) {
      let masterData = res?.data?.data;
      console.log("🚀 ~ getPackingReportTemplateInfo ~ masterData:", masterData);
      setViewData(masterData);
    }
  }, [id]);

  useEffect(() => {
    getPackingReportTemplateInfo();
  }, [getPackingReportTemplateInfo]);

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title="View Proforma Invoice"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <AddPackingReportTemplateForm ref={propertyFormRef} viewData={viewData} form={form} view={true} id={id} />
    </>
  );
}
